import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NotFoundPage = () => {
    const location = useLocation();
    const [language, setLanguage] = useState("hi");
    const [show404, setShow404] = useState(false);

    useEffect(() => {
        const pathLang = location.pathname.split("/")[1]; // e.g., "hi", "en"

        if (pathLang === "en") setLanguage("en");
        else if (pathLang === "hi") setLanguage("hi");
        else {
            const userLang = navigator.language || navigator.userLanguage;
            if (userLang.startsWith("en")) setLanguage("en");
            else setLanguage("hi");
        }

        // Delay showing 404 in case it's a valid route but not yet resolved
        const delay = setTimeout(() => setShow404(true), 200); // 200ms delay

        return () => clearTimeout(delay);
    }, [location]);

    const text = {
        hi: {
            title: "404",
            message: "ओह! जिस पेज को आप ढूंढ रहे हैं वह मौजूद नहीं है।",
            home: "होम पेज पर जाएं",
        },
        en: {
            title: "404",
            message: "Oops! The page you are looking for does not exist.",
            home: "Go to Home",
        },
    };

    const { title, message, home } = text[language];

    if (!show404) {
        // Optional: You can return a spinner or "Loading..." here
        return (
            <div className="d-flex vh-100 align-items-center justify-content-center bg-light">
                <div className="text-center p-4 shadow rounded bg-white">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex vh-100 align-items-center justify-content-center bg-light">
            <div className="text-center p-4 shadow rounded bg-white">
                <h1 className="display-1 text-danger">{title}</h1>
                <p className="fs-5 mb-4">{message}</p>
                <Link to={`/${language}/`} className="btn btn-primary">
                    {home}
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
